// Globals
import { ColumnsType } from 'antd/es/table';

// Components
import { Pagination } from '@/components';
import { Table } from '@/ui';
import { StyledWrapper } from '../Styled';

// Models
import { IFeedback } from '@/models/feedback.model';
import { GetProp } from 'antd/lib';

type TFeedbacksListProps = {
  list: IFeedback[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
  columns?: ColumnsType<IFeedback>;
  components?: GetProp<typeof Table, 'components'>;
};

const FeedbacksList = ({
  isLoading,
  list,
  total,
  currentPage,
  onPageChange,
  columns,
  components,
}: TFeedbacksListProps) => (
  <StyledWrapper>
    <Table
      columns={columns}
      loading={isLoading}
      dataSource={list}
      rowKey="id"
      scroll={{ x: 'max-content' }}
      components={components}
    />
    <Pagination hideOnSinglePage current={currentPage} total={total} onChange={onPageChange} />
  </StyledWrapper>
);

export default FeedbacksList;
